export default __webpack_public_path__ + "locales/zh-CN/HotkeysPanel.json?hash=4315b0c16c83dafd5848c798a36cc5d2";